// Импорт всех групп инструментов
import { basemapTool } from './basemap/basemapTool';
import { drawingTools } from './drawing';
import { measurementTools } from './measurement';

export { drawingTools, useDrawingTools } from './drawing';
export { measurementTools, useMeasurementTools } from './measurement';
// export { dataTools } from './data';
// export { exportTools } from './export';

// Общая коллекция всех инструментов
export const allTools = {
    ...drawingTools,
    ...measurementTools,
    // ...dataTools,
    // ...exportTools,
    'basemap': basemapTool
};
